<p-dropdown (onChange)='onChange($event.value)' [ngModel]='selectedType' [options]='types'>
</p-dropdown>
